import React from "react";
import Container from "@mui/material/Container";
import { getZIndex, sectionBackgroundColors } from "src/library/styles/theme";

type ConnectathonLogoProps = {
  alt: string;
};

export default function ConnectathonLogo(props: ConnectathonLogoProps) {
  const { alt } = props;

  return (
    <Container
      disableGutters
      sx={{
        py: 2,
        width: "100%",
        height: "fit-content",
        bgcolor: sectionBackgroundColors.logo,
        position: "relative",
        zIndex: getZIndex(sectionBackgroundColors.logo),
      }}
    >
      <img
        src="/images/connectathon/connectathon-logo512.png"
        alt={alt}
        style={{ objectFit: "contain", width: "100%", maxHeight: "300px" }}
      />
    </Container>
  );
}
